export default __webpack_public_path__ + "static/media/user-profile.cabf7251.svg";